// Utilitários para exportação de relatórios em CSV (separador ";" + BOM, padrão que o
// Excel pt-BR abre corretamente). Usado pelas telas de Histórico de Fechamentos e Caixa.

// Escapa um valor para uma célula de CSV: normaliza null/undefined, e envolve em aspas
// quando houver ";", aspas ou quebras de linha, dobrando aspas internas.
export function csvCell(valor: string | number | null | undefined): string {
    if (valor == null) return ""
    const texto = String(valor)
    if (/[";\n\r]/.test(texto)) {
        return `"${texto.replace(/"/g, '""')}"`
    }
    return texto
}

// Monta uma linha do CSV a partir de células já formatadas.
export function csvLinha(celulas: Array<string | number | null | undefined>): string {
    return celulas.map(csvCell).join(";")
}

// Gera o arquivo e dispara o download no navegador.
export function baixarCsv(nomeArquivo: string, linhas: string[]): void {
    const csv = linhas.join("\r\n")
    const blob = new Blob(["﻿" + csv], { type: "text/csv;charset=utf-8;" })
    const url = URL.createObjectURL(blob)
    const link = document.createElement("a")
    link.href = url
    link.setAttribute("download", nomeArquivo)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
}
